import { Empty } from "antd"

export const EmptyView = ({ name }) => {
    return (
        <div className="h-full flex items-center justify-center">
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                    <div>
                        You have no <span className="lowercase">{name}</span> at the moment.
                    </div>
                }
            />
        </div>)
}
